const data = {
  progId: null,
  stop: false
}

const mutations = {
  startPlayout (state, progId) {
    state.stop = false
    state.progId = progId
  },
  stopPlayout (state) {
    state.stop = true
  }
}

export default {
  namespaced: true,
  state: data,
  mutations: mutations
}
